import React, { useState, useEffect } from 'react';
import { get } from '../common/httpService';
import translateService from '../common/translateService';

import './BackToTop.scss';

function BannerRedirect() {
    const [bannerInfo, setBannerInfo] = useState({
        cancelUrl: '',
        okUrl: '',
        showBanner: false,
        targetCulture: 'en-US',
    });

    async function getBannerRedirectInfo() {
        try {
            get({
                url: `home/ShowBannerRedirect?currentUrl=${encodeURIComponent(
                    window.location.toString()
                )}`,
            }).then((bannerInfo) => {
                setBannerInfo(bannerInfo);
            });
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getBannerRedirectInfo();
    }, []);

    return bannerInfo.showBanner ? (
        <div id='redirect-message' className='message message--redirect'>
            <div className='message__text'>
                <strong>
                    {translateService.get(
                        `bannerRedirect.${bannerInfo.targetCulture}.speakLang`
                    )}
                </strong>{' '}
                {translateService.get(
                    `bannerRedirect.${bannerInfo.targetCulture}.buyOn`
                )}{' '}
                <a href={bannerInfo.okUrl} className='message__button'>
                    {translateService.get(
                        `bannerRedirect.${bannerInfo.targetCulture}.ok`
                    )}
                </a>
                <a href={bannerInfo.cancelUrl} className='message__button'>
                    {translateService.get(
                        `bannerRedirect.${bannerInfo.targetCulture}.cancel`
                    )}
                </a>
            </div>
        </div>
    ) : (
        <></>
    );
}

export default BannerRedirect;
